import { create } from "zustand";
import type {
  CareCoordinationContextMembership,
  CareCoordinationContextResponse,
} from "../types/careCoordinationAgency";

interface CareCoordinationContextState {
  memberships: CareCoordinationContextMembership[];
  activeOrganizationId: number | null;
  loaded: boolean;
  loading: boolean;
  error: string | null;
  setFromResponse: (response: CareCoordinationContextResponse) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clear: () => void;
}

const emptyState = {
  memberships: [] as CareCoordinationContextMembership[],
  activeOrganizationId: null as number | null,
  loaded: false,
  loading: false,
  error: null as string | null,
};

export const useCareCoordinationContextStore =
  create<CareCoordinationContextState>()((set) => ({
    ...emptyState,
    setFromResponse: (response) =>
      set({
        memberships: response.memberships ?? [],
        activeOrganizationId: response.active_organization_id ?? null,
        loaded: true,
        loading: false,
        error: null,
      }),
    setLoading: (loading) => set({ loading }),
    // Treat a failed load as terminal for this session so callers that
    // warm on mount (account shell / menu) do not retry forever.
    setError: (error) => set({ error, loading: false, loaded: true }),
    clear: () => set({ ...emptyState }),
  }));
